
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";
import u from "./umbrella-custom.js";

// Import application modules.
import { apiClient } from "./injector.js";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class BlogPostController extends Controller {

	/**
	* I get called whenever this instance is bound to a host element.
	*/
	connect() {

		// For now, the Stimulus controller is just going to proxy the old code. This will
		// give us some wiggle room when it comes to converting over to Hotwire without
		// the cleanest code.
		initGists( apiClient );

	}

}

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

async function getGist( apiClient, gistID ) {

	try {

		return await apiClient.makeRequest({
			url: "/index.cfm?event=api.blog.getGist",
			params: {
				gistID: gistID
			}
		});

	} catch ( error ) {

		var apiError = new Error( "GistFailure" );
		apiError.cause = error;

		throw( apiError );

	}

}


async function initGists( apiClient ) {

	var blogPost = u( "#blog-post" );

	var gistID = blogPost.data( "gist-id" );

	if ( ! gistID ) {

		return;

	}

	try {

		var data = await getGist( apiClient, gistID );

	} catch ( error ) {

		console.warn( "Failed to load and apply Gist to page." );
		console.error( error );
		Bugsnag?.notify( error );
		return;

	}

	// Check to see if the head already has this stylesheet - this will happen if the user
	// clicks from one post to another (and Hotwire is maintaining the context).
	if ( ! u( `style[data-hash="${ data.stylesheet.contentHash }"]` ).length ) {

		u( document.createElement( "style" ) )
			.attr( "type", "text/css" )
			.attr( "data-hash", data.stylesheet.contentHash )
			.html( data.stylesheet.content )
			.appendTo( document.head )
		;

	}

	blogPost
		.find( "div.code[ data-gist-filename ]" )
		.each(
			function iterator( node ) {

				var filename = node.dataset.gistFilename;

				if ( ! data.fileIndex[ filename ] ) {

					return;

				}

				node.innerHTML = data.fileIndex[ filename ];

			}
		)
	;

	// After the gist is applied, the dimensions of the content may have shifted. As such,
	// let's see if we have a URL fragment for which we may need to update the scrolling.
	if ( window.location.hash ) {

		window.setTimeout(
			function showTarget() {

				// Since the hash is a user-provided value, we can't trust it. It's going
				// to be possible for a hash to be set that does not represent a valid
				// SELECTOR (such as Chrome's auto-highlight feature).
				try {

					var target = u( window.location.hash );

					if ( target.length ) {

						target.scroll();

					}

				} catch ( error ) {

					console.error( error );

				}

			},
			500
		);

	}

}
